export const PrivacySettingActionTypes = {
    FETCH_PRIVACY_SETTING_REQUEST:
        "@@PrivacySetting/FETCH_PRIVACY_SETTING_REQUEST",
    FETCH_PRIVACY_SETTING_SUCCESS:
        "@@PrivacySetting/FETCH_PRIVACY_SETTING_SUCCESS",
    FETCH_PRIVACY_SETTING_FAILURE:
        "@@PrivacySetting/FETCH_PRIVACY_SETTING_FAILURE",

    FETCH_OTHER_PRIVACY_SETTING_REQUEST:
        "@@PrivacySetting/FETCH_OTHER_PRIVACY_SETTING_REQUEST",
    FETCH_OTHER_PRIVACY_SETTING_SUCCESS:
        "@@PrivacySetting/FETCH_OTHER_PRIVACY_SETTING_SUCCESS",
    FETCH_OTHER_PRIVACY_SETTING_FAILURE:
        "@@PrivacySetting/FETCH_OTHER_PRIVACY_SETTING_FAILURE",

    UPDATE_PRIVACY_SETTING_REQUEST:
        "@@PrivacySetting/UPDATE_PRIVACY_SETTING_REQUEST",
    UPDATE_PRIVACY_SETTING_SUCCESS:
        "@@PrivacySetting/UPDATE_PRIVACY_SETTING_SUCCESS",
    UPDATE_PRIVACY_SETTING_FAILURE:
        "@@PrivacySetting/UPDATE_PRIVACY_SETTING_FAILURE",
};
